import React from 'react';
import { useTranslation } from 'react-i18next';
import { translations } from 'translations';

export interface ISeparatorProps {
  /**
   * Optional text or translation key. Defaults to 'o'.
   */
  label?: string;
  /**
   * Custom CSS tailwind styles for the container.
   */
  className?: string;
}

export const Separator: React.FC<ISeparatorProps> = ({
  label,
  className = "my-6"
}) => {
  const { t } = useTranslation();

  return (
    <div className={`relative w-full flex items-center justify-center ${className}`}>
      <div className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-gray-100"></div>
      </div>
      <span className="relative bg-white px-4 text-xs font-bold text-gray-300 uppercase tracking-widest">
        {label || t('common.or', 'o')}
      </span>
    </div>
  );
};
